import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import UsersApi from "Api/UsersApi/UsersApi";
import {
  errorNotification,
  loadingNotification,
  successNotification,
  updateToError,
  updateToSuccessNotification,
} from "Components/MyNotification";
import { setLoading } from "../MainSlice/MainSlice";

export const loginUserThunk = createAsyncThunk(
  "users/login",
  async (data, thunkAPI) => {
    try {
      const result = await UsersApi.login(data);

      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      if (result.status === "success") {
        return result.dto;
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const logoutUserThunk = createAsyncThunk(
  "users/logout",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoading(true));
      const userId = thunkAPI.getState().user.user.id;
      const result = await UsersApi.logout(userId);
      if (result.status === "fail") {
        errorNotification(result.message);
        thunkAPI.dispatch(setLoading(false));
        return thunkAPI.rejectWithValue(result.message);
      }
      if (result.status === "success") {
        successNotification(result.dto);
        thunkAPI.dispatch(setLoading(false));
        return;
      }
    } catch (err) {
      thunkAPI.dispatch(setLoading(false));
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const getAllUsersThunk = createAsyncThunk(
  "users/getAllUsers",
  async (data, thunkAPI) => {
    try {
      const page = data?.page || 1;
      const searchValue = data?.searchValue || "";
      const result = await UsersApi.getAll(page, searchValue);
      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      if (result.status === "success") {
        return result.dto;
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const updateUserThunk = createAsyncThunk(
  "users/updateUser",
  async (userData, thunkAPI) => {
    const toastId = loadingNotification("Оновлення користувача...");

    try {
      const result = await UsersApi.updateUser(userData);

      if (result.status === "fail") {
        updateToError(toastId, result.message);
        return thunkAPI.rejectWithValue(result.message);
      }

      updateToSuccessNotification(toastId, "Користувача успішно оновлено");
      await thunkAPI.dispatch(getAllUsersThunk());
      return result.dto;
    } catch (err) {
      updateToError(toastId, err.message || "Помилка оновлення");

      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const getAllRolesThunk = createAsyncThunk(
  "users/getAllRoles",
  async (_, thunkAPI) => {
    try {
      const result = await UsersApi.getAllRoles();

      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      if (result.status === "success") {
        return result.dto;
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const createUserThunk = createAsyncThunk(
  "users/createUserRegistration",
  async (userData, thunkAPI) => {
    const toastId = loadingNotification("Створення користувача...");

    try {
      const result = await UsersApi.registration(userData);

      if (result.status === "fail") {
        updateToError(toastId, result.message);
        return thunkAPI.rejectWithValue(result.message);
      }

      updateToSuccessNotification(toastId, "Створено нового користувача");
      return result.dto;
    } catch (err) {
      updateToError(toastId, err.message || "Помилка створення");
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const refreshUserThunk = createAsyncThunk(
  "users/refreshUser",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoading(true));
      const result = await UsersApi.refreshUser();

      if (result.status === "fail") {
        // errorNotification("Ви не авторизовані!");
        thunkAPI.dispatch(setLoading(false));
        return thunkAPI.rejectWithValue(result.message);
      }
      if (result.status === "success") {
        thunkAPI.dispatch(setLoading(false));
        // successNotification("Успішна авторизація!");
        return result.dto;
      }
      thunkAPI.dispatch(setLoading(false));
    } catch (err) {
      thunkAPI.dispatch(setLoading(false));
      return thunkAPI.rejectWithValue(err);
    }
  },
);

const initialState = {
  isAuth: false,
  isLoading: false,
  user: {},
  roles: [],
  usersList: [],
  allRoles: [],
  currentPage: 1,
  totalPages: 1,
  total: 1,
  isRefreshing: true,
};

const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserAfterRefreshAxios: (state, action) => {
      const { id, name, roles } = action.payload;
      state.isLoading = false;
      state.isAuth = true;
      state.user = { id, name };
      state.roles = roles;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(refreshUserThunk.pending, (state, action) => {
      state.isRefreshing = true;
    });

    builder.addCase(refreshUserThunk.fulfilled, (state, action) => {
      const { user, accessToken } = action.payload;
      const { id, name, roles } = user;
      state.isLoading = false;
      state.isAuth = true;
      state.user = { id, name };
      state.roles = roles;
      state.isRefreshing = false;
      localStorage.setItem("accessTokenPA", accessToken);
    });
    builder.addCase(refreshUserThunk.rejected, (state, action) => {
      state.isRefreshing = false;
    });
    builder.addCase(loginUserThunk.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(loginUserThunk.fulfilled, (state, action) => {
      const { user, accessToken } = action.payload;
      const { id, name, roles } = user;
      state.isLoading = false;
      state.isAuth = true;
      state.user = { id, name };
      state.roles = roles;
      localStorage.setItem("accessTokenPA", accessToken);
    });
    builder.addCase(loginUserThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(logoutUserThunk.fulfilled, (state, action) => {
      localStorage.removeItem("accessTokenPA");
      return initialState;
    });
    builder.addCase(getAllUsersThunk.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllUsersThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      const { total, data, currentPage, totalPages } = action.payload;
      state.usersList = data;
      state.currentPage = currentPage;
      state.total = total;
      state.totalPages = totalPages;
    });
    builder.addCase(getAllUsersThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(getAllRolesThunk.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllRolesThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.allRoles = action.payload;
    });
    builder.addCase(getAllRolesThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { setUserAfterRefreshAxios } = UserSlice.actions;
export const selectUser = (store) => store.user;

export default UserSlice.reducer;
